import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { LOCAL_STORAGE_CONSTANTS } from '../constants/local.storage.constants';
import { LocalStorageHelper } from '../helpers/local.storage.helper';
import { environment } from '../../../environments/environment';
import { excludedUrls } from '@core/constants/excluded-error-urls.contans';
import { MatDialog } from '@angular/material/dialog';
import { ServerErrorDialogComponent } from '../../shared/components/server-error-dialog/server-error-dialog.component';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class HttpConfigInterceptor implements HttpInterceptor {
  private _unsubscribe = new Subject<void>();

  constructor(
    private _router: Router,
    private localStorageHelper: LocalStorageHelper,
    private toast: ToastrService,
    private matDialog: MatDialog,
  ) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (!window.navigator.onLine) {
      // if there is no internet, throw a HttpErrorResponse error
      // since an error is thrown, the function will terminate here
      this.toast.error('Por favor verifique su conexión a internet', 'Sin conexión')
      return throwError('Sin conexión a Internet');
    }

    const token: string = this.localStorageHelper.getItem(
      LOCAL_STORAGE_CONSTANTS.TOKEN
    );

    // Si hay token lo seteamos
    if (!request.headers.has('noAuth') && token && !request.url.includes('apiip.net')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },

      });
    }

    if (excludedUrls.some(url => request.url.split('/v1/')[1]?.startsWith(url))) {
      return next.handle(request);
    }

    // Peticiones
    return next.handle(request).pipe(
      map((event: any) => {
        try {
          const myBody = event.body;
          let token: string = myBody.data.accessToken || '';
          // Si tienes Token refrescalo
          if (token) {
            localStorage.setItem('accessToken', myBody.data.accessToken);
            // this.AuthenticationServiceImpl.saveToken(myBody.data);
          }
          let expiresIn: string = myBody.data.expiresIn || '';
          // Si tienes Token refrescalo
          if (expiresIn) {
            localStorage.setItem('expiresIn', myBody.data.expiresIn);
          }
        } catch (error) { }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        var errorCode = error.status;
        if (error.status === 400 && request.url.includes('/v1/horarios/ejecucion/programacion-fija') && error.error
          && error?.error.message === 'Ocurrio un error al ejecutar la programacion de horario fijo') {
            return throwError(() => error);
          }
        if (
          error instanceof HttpErrorResponse &&
          ((error.status >= 500 || error.status === 403) && error.status != 504)
        ) {
          const dialogRef = this.matDialog.open(ServerErrorDialogComponent, {
            data: { errorResponse: error },
            hasBackdrop: false,
            width: "80vw",
          });
          dialogRef.updatePosition({ top: "15%" });

        } else {
          if (errorCode === 0 || errorCode === 401) {
            // Reiniciamos Todo
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Ha ocurrido un error.',
              text: error.error.message,
              showConfirmButton: true,
              allowOutsideClick: false
            });
          }
          // Otros errores
          else {
            if (errorCode != 504) {
              if (error.error) {

                if (error.error.errors) {
                  for (const errors of error.error.errors) {
                    if(request.url.includes('/v1/plan-especial/') && error.error.errors[0].field.includes("Error Plan Especial")){
                      return throwError(() => error);
                    } else if(request.url.includes('/v1/solicitar-horario/')) {
											return throwError(() => error);
										} else if(request.url.includes('/v1/contrato-process/revertir-apto-suscripcion')) {
											return throwError(() => error);
										}
                    this.toast.error(errors.message, errors.field);
                  }
                } else {
                  if (request.url.includes('/v1/personas/documento/') && request.url.includes('/fotografia') && !environment.production) {
                    if (error.error.message == "No se pudo encontrar el file.") {
                      this.toast.warning("No se ha encontrado una foto, por favor cargue una.");
                    } else {
                      this.toast.warning(error.error.message);
                    }
                  }
                  else {
                    Swal.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Ha ocurrido un error.',
                      text: error.error ? error.error.message || error.error.error_description : error,
                      showConfirmButton: true,
                      allowOutsideClick: false
                    });
                  }
                }
              }
            }
          }
        }

        // Retorna el error
        return throwError(() => error);
      }),
      finalize(() => {
        this._unsubscribe.next();
        this._unsubscribe.complete();
      })
    );
  }
}
